module.exports = __webpack_public_path__ + "img/profile.e6fa499c.png";